<template>
    <div class="topicPage topicPage-fullScreen">
        <header class="survey-header">
            <div class="survey-title">
                <img src="../../../assets/images/common/nav_logo.png" alt="">
                <h1>{{surveyPropInfo?surveyPropInfo.name:''}}</h1>
                <el-button @click="closeFn" type="danger" size="small" round><i class="nucfont inuc-close"></i>
                </el-button>
            </div>
        </header>

        <div class="survey-container">
            <section class="paper-list" v-for="(item, index) in surveyPropData">
                <!--单选题-->
                <ul>
                    <li v-if="item.type==2" class="survey-single sur-title">
                        <div class="topic-header">
                            <h3 class="title-order">{{index+1+'、'}}</h3>
                            <h3 class="title-des">{{item.title}}</h3>
                        </div>
                        <div class="survey-single-rate">
                            <i v-for="i in 5" :key="i" class="el-icon-star-on"></i>
                        </div>
                    </li>
                    <!--多选题-->
                    <li v-if="item.type==3" class="survey-multi">
                        <div class="sur-title multi-title">
                            <h3 class="title-order">{{index+1+'、'}}</h3>
                            <h3 class="title-des">{{item.title}}</h3>
                        </div>
                        <ul class="multi-txt">
                            <li v-for="(ele,i) in item.options" :key="i">
                                <p class="option-order">{{String.fromCharCode(i+65)+'、'}}</p>
                                <p class="option-des">{{ele.title}}</p>
                            </li>
                        </ul>
                    </li>
                    <!--主观题-->
                    <li v-if="item.type==4" class="survey-subjective">
                        <div class="sur-title sub-title">
                            <h3 class="title-order" style="width: 26px">{{index+1+'、'}}</h3>
                            <h3 class="title-des">{{item.title}}</h3>
                        </div>
                        <div class="subjective-txt">
                            {{$t('tip.txtContent')}}
                        </div>
                    </li>
                </ul>
            </section>
        </div>
        <div class="fullscreen-wrapper" v-if="loading" v-loading="true">
            <p>{{$t('exam.loading')}}</p>
        </div>
    </div>
</template>

<script>
    import {screenfull} from '@/utils';
    import FullScreen from '@components/FullScreen.vue';

    export default {
        props: {
            surveyPropData: {
                required: true,
            },
            surveyPropInfo: {
                required: true,
            }
        },
        data() {
            return {
                multiMode: true,
                tableData: [],
                loading: true,
            }
        },
        created() {
        },
        mounted() {
            this.$scrollElement = $('.survey-container');
        },
        computed: {},
        methods: {
            closeFn() {
                this.$emit('close');
            },
        },
        watch: {
            surveyPropData: {
                handler: function (val) {
                    if (val.length) {
                        setTimeout(() => {
                            this.loading = false;
                        }, 500);
                    }
                },
            }
        },
        beforeDestroy() {
            screenfull.exit();
        },
        components: {
            FullScreen,
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const';

    @include scrollbar(#999);
    $border: 1px solid #ebebeb;

    .topicPage {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 2000;
    }

    .survey-title {
        display: flex;
        align-items: center;
        padding: 0 30px;
        height: 56px;
        background-color: $c-dark-header;

        img {
            height: 55%;
        }

        h1 {
            flex: 1;
            text-align: center;
            font-size: 20px;
            color: #fff;
            letter-spacing: 2px;
        }
    }

    .survey-container {
        overflow: auto;
        position: relative;
        padding: 20px 0 50px;
        .sur-title {
            padding: 15px 20px;
            background: #fafafc;
            border-bottom: $border;
        }
        .multi-title,
        .sub-title,
        .topic-header {
            position: relative;
            .title-order {
                position: absolute;

            }
            .title-des {
                padding-left: 30px;
                word-wrap: break-word;
            }
        }
        .survey-single,
        .survey-multi,
        .survey-subjective {
            width: 70%;
            min-width: 900px;
            margin: 20px auto 0;
            border: $border;
            font-size: 16px;
        }
        .survey-single {
            display: flex;
            .topic-header,
            .survey-single-rate {
                display: inline-block;
            }
            .survey-single-rate {
                width: 160px;
                text-align: center;
                float: right;
                .el-icon-star-on{
                    font-size: 25px;
                    color: #cdcdcd;
                    margin-left: 4px;
                    vertical-align: middle;
                }
            }
            .topic-header {
                flex: 1;
                word-wrap: break-word;
                overflow: hidden;
            }
        }
        .survey-multi {
            .multi-txt {
                padding: 10px 20px;
                li {
                    margin: 10px 0;
                    color: #979aa3;
                    position: relative;
                    .option-order {
                        position: absolute;
                    }
                    .option-des {
                        word-wrap: break-word;
                        padding-left: 30px;
                    }
                }
            }
        }
        .survey-subjective {
            .subjective-txt {
                padding: 15px 20px 15px 50px;
                color: #979aa3;
            }
        }
    }
    .fullscreen-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 3000;

        > p {
            position: absolute;
            top: 53%;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
            color: #000;
            z-index: 9000;
        }
    }

</style>
